import {Component, ViewChild} from '@angular/core';
import {Router} from "@angular/router";

// components
import {CarFormComponent} from "../car-form/car-form.component";

// services
import {CarsService} from "../../../shared/services/cars.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";

// models
import {ApiMessage} from "../../../shared/models/api-message";


@Component({
    selector: 'app-car-save',
    templateUrl: './car-save.component.html',
    styleUrl: './car-save.component.scss'
})
export class CarSaveComponent {

    @ViewChild('data') data!: CarFormComponent;

    public isSaved = false;

    constructor(private carsService: CarsService,
                private snackbarService: SnackbarService,
                private router: Router) {
    }

    public addCar(): void {
        this.isSaved = true;
        this.carsService.createCar(this.data.carForm.getRawValue()).subscribe({
            next: (res: ApiMessage): void => {
                this.snackbarService.snackbarCustomComplete(res.message);
            },
            error: (e) => this.snackbarService.snackbarCustomError(e.error.message),
            complete: () => {
                this.closeForm();
                this.isSaved = false;
            }
        })
    }

    public closeForm(): void {
        this.router.navigateByUrl('/secure/cars').then();
    }
}
